var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "c--shared_currencies-list",
    class: `currencies-list-wrapper type-modal searchable}`
  }, [_c('div', {
    staticClass: "currencies-list-container",
    attrs: {
      "data-testid": "currencies-list"
    }
  }, [_c('box-simple', {
    staticClass: "w-100",
    attrs: {
      "shadowed": _vm.isShadowedBox,
      "rounded": _vm.isRoundedBox
    }
  }, [_c('div', {
    staticClass: "currencies-list-header px-20"
  }, [_c('p', {
    staticClass: "title-sub"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "currencies-list-search-container"
  }, [_c('span', {
    staticClass: "icon search"
  }, [_c('i', {
    staticClass: "airalo-icon-search"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.searchValue,
      expression: "searchValue"
    }],
    staticClass: "currencies-list-search w-100",
    attrs: {
      "placeholder": _vm.searchInputPlaceholder,
      "data-testid": "currencies-list-search-bar",
      "type": "text"
    },
    domProps: {
      "value": _vm.searchValue
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.searchValue = $event.target.value;
      }
    }
  }), _vm._v(" "), _vm.searchValue.length > 0 ? _c('span', {
    staticClass: "icon close-icon",
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.clearSearch.apply(null, arguments);
      }
    }
  }, [_c('i', {
    staticClass: "airalo-icon-close-round-filled"
  })]) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "currencies-list",
    class: {
      'empty-list': !_vm.searchedCurrencyList.length,
      'd-grid': _vm.searchedCurrencyList.length > 0
    }
  }, [_vm._l(_vm.searchedCurrencyList, function (currency, index) {
    return _c('li', {
      key: `popup-currencies-list-${index}`,
      class: {
        active: currency.code === _vm.$i18n.locale,
        'is-browser-locale': _vm.browserLocale === currency.code
      }
    }, [_c('div', {
      staticClass: "currency-name"
    }, [_c('a', {
      staticClass: "d-flex justify-content-between align-items-center",
      class: {
        'tw-font-semibold': currency.code === _vm.currentCurrencyCode
      },
      attrs: {
        "data-testid": `${currency.code}-currency-select`,
        "dir": _vm.$dir()
      },
      on: {
        "click": function ($event) {
          $event.preventDefault();
          return _vm.onCurrencySelected(currency);
        }
      }
    }, [_c('span', {
      class: {
        'text-right': _vm.$dir() === 'rtl'
      }
    }, [_vm._v(_vm._s(_vm.currencyFullName(currency)))]), _vm._v(" "), currency.code === _vm.currentCurrencyCode ? _c('i', {
      staticClass: "airalo-icon-tick-round-filled"
    }) : _vm._e()])])]);
  }), _vm._v(" "), !_vm.searchedCurrencyList.length ? _c('li', {
    staticClass: "empty"
  }, [_c('p', [_vm._v(_vm._s(_vm.emptyText || _vm.$t('global.no-currency-available')))])]) : _vm._e()], 2)])], 1), _vm._v(" "), _c('client-only', [_c('confirm-currency-change-modal', {
    attrs: {
      "modal-view": _vm.isConfirmCurrencyChangeModalShown,
      "overlay-view": false,
      "type": "double",
      "text": _vm.currencyChangeModalTitle,
      "button": {
        text: _vm.$t('global.cancel'),
        isClose: true
        // class: 'button button-secondary-outline',
      },
      "button-second": {
        text: _vm.$t('components.change.currency.positive-button'),
        class: 'btn-prompt-simple-secondary'
      }
    },
    on: {
      "onCloseModal": _vm.onCancelCurrencyChangeModal,
      "onClickButton": _vm.onConfirmCurrencyChangeModal
    }
  }, [_c('p', {
    staticClass: "tw-text-14 tw-mt-4 text-center"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('components.confirm-currency-change.info')) + "\n      ")])])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }